import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OverflowFrame, PageHeading } from "../../externalComponents";
import { useIsMobile } from "../../externalComponents/useIsMobile";
import { CustomerContext } from "../../providers";
import OngoingSendings from "./components/OngoingSendings";
import PastSendings from "./components/PastSendings";
import ScheduledSendings from "./components/ScheduledSendings";
import StoppedSendings from "./components/StoppedSendings";

export default function SendingsPage() {
  const { user } = useContext(CustomerContext);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <>
      <PageHeading
        title="Sendings"
        primaryAction="Back"
        handlePrimaryAction={() => navigate("/campaigns")}
      />
      <OverflowFrame>
        <div className="mx-3 md:mx-0">
          <StoppedSendings user={user} isMobile={isMobile} />
          <ScheduledSendings user={user} isMobile={isMobile} />
          <OngoingSendings user={user} isMobile={isMobile} />
          <PastSendings user={user} isMobile={isMobile} />
          <br />
        </div>
      </OverflowFrame>
    </>
  );
}
